const contentfulGraphqlApi = "https://graphql.contentful.com/content/v1/spaces/";

export const tagSpaceId = process.env.CONTENTFUL_TAG_SPACE_ID;
export const tagSpaceEnvironment = process.env.CONTENTFUL_TAG_SPACE_ENVIRONMENT_ID || "master";
export const tagSpaceAccessToken = process.env.CONTENTFUL_TAG_SPACE_ACCESS_TOKEN;
export const tagSpacePreviewAccessToken = process.env.CONTENTFUL_TAG_SPACE_PREVIEW_ACCESS_TOKEN;

export const contentfulTagSpaceUrl = `${contentfulGraphqlApi}${tagSpaceId}/environments/${tagSpaceEnvironment}`;

export const POP_OFFICES_ENTRY_ID_PROD = "1DiJfcZF1FjCRhKzfsB8FM";
export const POP_OFFICES_ENTRY_ID_NON_PROD = "5nMhh1EGVDgK1cjf1RF2bN";

export const GOOGLE_MAPS_API_KEY = "AIzaSyClooL5cgdYpLGVq_99SjjHEh3vtf8R73M";
export const SCHEDULE_APPOINTMENT_BASE_PATH = "/schedule-an-appointment/";
export const PATIENT_SERVICES_BASE_PATH = "/patient-services/";
export const ODP_Base_Path = "/dentist";
export const POP_Base_Path = "/about/real-estate";

// Slug of the bb 404 page authored in Contentful Studio, rendered as
// the not-found body by ExperienceWrapper. The 404 <title> is not sourced from
// this experience — see NOT_FOUND_METADATA in getPageMetadata.
export const NOT_FOUND_SLUG = "404";
export const Google_Maps_Business_Url =
  "https://www.google.com/maps/search/?api=1&query=Aspen Dental, ";
export const Google_Maps_Directions_Url = "https://www.google.com/maps/dir/?api=1&destination=";

export const LOCAL_STORAGE_KEYS = {
  FACILITY_CODE: "facilityCode",
  LEAD_GEN_FORM_SUBMITTED: "LEAD_GEN_FORM_SUBMITTED",
};
export const STORAGE_SESSION_ID_KEY = "sessionId";
export const ONE_TRUST_TOGGLE = "toggle-cookie-display";

// Default map coordinates (US Geographic Center - Kansas)
// Used as fallback when office and CloudFront geo coordinates are unavailable
export const DEFAULT_MAP_COORDINATES = {
  lat: 39.8283,
  lng: -98.5795,
};

export const FULTON_MARKET_OFFICE_COORDINATES = {
  lat: 41.886925,
  lng: -87.648236,
};

export const CACHE_CONTROL_NO_CACHE = "no-cache, max-age=0, must-revalidate";

// max rating is always 5
export const FILTERED_REVIEWS_MAX_RATING = 5;

// need to show only 3 in UI
// some reviews may not have comments
// so fetching 10 and getting 3 with the comments to be safe
export const FILTERED_REVIEWS_TAKE = 10;

export const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const DAYS_OF_WEEK_SHORT_HAND: Record<string, string> = {
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat",
  Sunday: "Sun",
};

export const STATE_CODES: Record<string, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

// The /smile experiences are fully authored in Contentful, including their own
// header band and footer, so the global code chrome never renders on that
// subtree. Uses the hideHeader/hideFooter path grammar (a trailing "/*" also
// matches the parent path itself, see lib/utils/path-matches).
export const CONTENTFUL_AUTHORED_CHROME_PATHS = ["/smile/*"];

// The shared /smile header: a Contentful experience the catch-all route
// injects (SlotExperience) on /smile pages that have been converged onto it,
// replacing the per-page header band copies that used to drift. Editing this
// single entry changes the header only on the pages where the shared slot is
// injected; pages that still carry their own embedded header band are edited
// per page until they are backfilled to this slot (BRIDGE GUARD in
// app/[...slug]/page.tsx). Convergence target: one entry, edited once.
export const SMILE_CHROME_HEADER_SLUG = "smile/bb/chrome/header";

/**
 * The Contentful entries the /smile footer reads its content from (Bailey
 * Hill edits these, no BB release): TAG's own Footer content type (`adFooter`)
 * for the logo, five link columns, Follow us row, phone, copyright and the
 * legal paragraph, plus two Footer Navigation Groups for the policy strip and
 * the family-of-brands marks. Same ids in every environment (Testing first;
 * TAG's import carries them to development/master), so a door where the
 * entries are not published yet renders the code defaults unchanged.
 * Provisioned by scripts/smile/d10-smile-footer-entry.mjs; runbook
 * docs/smile-footer-entry.md.
 */
export const SMILE_FOOTER_ENTRY_IDS = {
  footer: "bbSmileFooter",
  policyGroup: "bbSmileFooterPolicy",
  familyGroup: "bbSmileFooterFamily",
} as const;

/**
 * The Contentful entry the /smile header reads its nav row from (Bailey Hill
 * edits it, no BB release): a Navigation Group, TAG's own header sub-nav
 * container, whose Links field holds the six Navigation Links. It is the
 * same entry a canvas placement binds to Nav Items, so a bound atom, an
 * unbound atom, the shared slot's atom and the code fallback all render the
 * one list. Same id in every environment (Testing first; TAG's import carries
 * it to development/master), so a door where it is not published renders the
 * code defaults unchanged. Provisioned by scripts/smile/d5-nav-footer-entries.mjs;
 * runbook docs/smile-chrome-link-entries.md.
 */
export const SMILE_HEADER_ENTRY_IDS = {
  navGroup: "bbSmileHeaderNav",
} as const;

// The /smile desktop mega menu PANEL CONTENT: one Contentful experience
// (slug-convention sibling of the chrome header entry) holding a panel
// section per nav category. page.tsx renders it into a code-owned wrapper
// that SmileMegaMenu.tsx keeps out of flow and presents as the click-open
// Warby-style sheet (warby-parity-20260830 matrix rows F1/F2). Content is
// authored; ONLY the disclosure behavior lives in code (A-01 split).
export const SMILE_MEGA_PANELS_SLUG = "smile/bb/chrome/mega-menu";

// Nav flyout kill switch (Chris + Nathan live review, 2026-08-31: "we need to
// remove the fly out from the nav and just do direct links" / "we need to
// defer the fly outs for now"). While false, SmileMegaPanelsSlot renders
// nothing: the SmileMegaMenu enhancer never mounts and the authored band's
// six category anchors stay plain <a> DIRECT LINKS to their category pages
// (/smile/emergency/, /smile/dentures/, /smile/implants/, /smile/checkup/,
// /smile/clear-aligners/, /smile/dental-insurance/ - the same hrefs the
// mega menu's trigger<->panel classifier keyed on). Phone + Book Online are
// untouched. Flip back to true to restore the Warby click-open sheet; all
// flyout code and the authored panels entry stay intact.
export const SMILE_NAV_FLYOUT_ENABLED = false;

// VWO visitor tracking
export const VWO_USER_ID_HEADER = "x-vwo-visitor-id";

// Appointment booking cookie (written by external booking system)
export const APPOINTMENT_COOKIE = "aspen_appointment";

// Immutable map of custom DOM events dispatched by the Button component.
// Add new button-related events here as additional key/value pairs.
export const BUTTON_EVENTS = Object.freeze({
  OPEN_LOCATION_DRAWER: "aspen:open-location-drawer",
} as const);
